export class DraggableCompareByService {
  public static addIndex(value) {
    if (Array.isArray(value)) {
      return value.map((x, index) => ({ ...x, index }));
    }

    return { ...value };
  }
}
